module.exports = __webpack_public_path__ + "Assets/e31c4487-0242-4de0-8b75-7e0330196edc.svg";